<template>
  <div>
    <span v-if="search.length > 0">
      Your search for "{{ search }}" found no results.
    </span>
    <vue-default-svg-loader v-else-if="loading"></vue-default-svg-loader>
    <vue-no-data v-else :text="text" :height="height">
      <slot></slot>
    </vue-no-data>
  </div>
</template>
<script>
export default {
  props: {
    search: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      default: "No data available at the moment"
    },
    height: {
      type: [String, Number],
      default: 200
    }
  }
};
</script>
